import { gql } from '@apollo/client'

const GET_MISCELLANEOUS_TAXES = gql`
  query GetMiscellaneousTaxes($filters: JSON) {
    miscellaneousTaxes(filters: $filters) {
      collection {
        id
        createdAt
        ticketDocumentNumber
        transactionId
      }
      metadata {
        totalCount
        currentPage
        limitValue
      }
    }
  }
`

export default GET_MISCELLANEOUS_TAXES
